import { useState } from "react";
import { useAttemptHistory } from "@/hooks/useExam";
import AttemptHistory from "@/components/dashboard/AttemptHistory";

export default function History() {
  const [page, _setPage] = useState(1);
  const { data, isLoading, error } = useAttemptHistory(page);

  return (
    <div className="page-enter mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">History</h1>
        <p className="mt-2 text-gray-500">
          Review your past exam and category practice attempts.
        </p>
      </div>

      <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
        {isLoading && (
          <div className="flex items-center justify-center py-20">
            <svg className="animate-spin h-8 w-8 text-primary-600" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
          </div>
        )}

        {error && (
          <div className="p-6 text-center">
            <p className="text-danger-600">Failed to load history. Please try again later.</p>
          </div>
        )}

        {data && (
          <AttemptHistory attempts={data} />
        )}
      </div>
    </div>
  );
}
